import { useTranslation } from 'react-i18next';
import { InlineAlert } from '@scramble/ui';
import PaymentModule from '@/containers/PaymentModule';
import { useGetMe } from '@/hooks/shared/useGetMe';
import WarningBlock from '@/components/UI/WarningBlock';
import { ROLES } from '@/helpers/constants';
import s from './index.module.scss';

const PaymentsAddFundsPage = () => {
  const { user, hasAddCashRestriction } = useGetMe();
  const { t } = useTranslation('cash');

  if (!user) return null;

  const isAdmin = user.role === ROLES.founder;
  const canAddCash = isAdmin && !hasAddCashRestriction;

  return (
    <div className={s.wrapper}>
      {!isAdmin && (
        <WarningBlock withBorder className={s.message}>
          <div className="f-16 f-400">{t('add_funds_page.add_funds_unavailable_message')}</div>
        </WarningBlock>
      )}
      {isAdmin && hasAddCashRestriction && (
        <InlineAlert
          type="warning"
          className={s.message}
          title={t('add_funds_page.operation_unavailable_title')}
          message={t('add_funds_page.add_funds_aml_unavailable')}
        />
      )}
      <PaymentModule disabled={!canAddCash} />
    </div>
  );
}

export default PaymentsAddFundsPage;
